import {queryOptions} from '@tanstack/react-query'
import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/start'
import {z} from 'zod'
import fetchPromotions from '~/client/spreadshop/old/fetchPromotions'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 // 1h

const promotionsParams = z
    .object({
        locale: z.nativeEnum(Locale).optional(),
    })
    .optional()

const getPromotions = createServerFn({
    method: 'GET',
})
    .validator((data: unknown) => {
        const result = promotionsParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }

        return result.data
    })
    .handler(async ({data}) => {
        const {locale} = data ?? {}

        const response = await fetchPromotions(locale)

        applyServerFnCache(CACHE_TIME_SEC)

        const promotions = response.shop?.promotions?.items ?? []

        return promotions.sort((a, b) => (b?.discountPercent ?? 0) - (a?.discountPercent ?? 0))
    })

export const promotionsQueryOptions = (locale: Locale = Locale.EnEu) =>
    queryOptions({
        queryKey: ['promotions'],
        queryFn: () => getPromotions({data: {locale}}),
        gcTime: 1000 * CACHE_TIME_SEC, // 1h
        staleTime: 1000 * CACHE_TIME_SEC, // 1h
    })
